import { BettingLineData } from '../api/types/BettingLineData';  // Adjust the path as necessary

export class SportsbookVm {
    sportsbookName: string;
    sportsbookFeedKey: string;
    sportsbookLogo: string;
    sportsbookClickout: string;
    providerBookId: string; // sharpsports ID

    constructor(sportsbookData: BettingLineData) {
        this.sportsbookName = sportsbookData.sportsbookName;
        this.sportsbookFeedKey = sportsbookData.sportsbookFeedKey;
        this.sportsbookLogo = sportsbookData.sportsbookLogo;
        this.sportsbookClickout = sportsbookData.sportsbookClickout;
        this.providerBookId = sportsbookData.providerBookId;
    }
}
